import fetch from './fetch';
import { filter, map, pipe, reduce, values } from 'ramda';

import { ENV } from '../settings/env';
import { countryCode as realCountryCode } from './country';
import { countryCode } from './translator';
import {
  POS_ANNOUNCEMENT_URLS,
  POS_POSITION_URLS,
  POS_FILTERS_URLS,
  POS_POSITION_LAT_DELTA,
  POS_POSITION_LNG_DELTA,
  POS_SEARCH_URLS
} from '../settings/pointOfSale';

export function getPointsOfSale() {
  return fetch(POS_POSITION_URLS[ENV](realCountryCode))
    .then(response => response.json())
    .then(unmergeAllPoints)
    .then(addZIndex);
}

export function getFilters() {
  return fetch(POS_FILTERS_URLS[ENV])
    .then(response => response.json());
}

export function getSearchResults(ids) {
  return fetch(POS_SEARCH_URLS[ENV](ids))
    .then(response => response.json());
}

export function getAnnouncement() {
  return fetch(POS_ANNOUNCEMENT_URLS[ENV](countryCode))
    .then(response => response.json());
}

let zIndex = 0;
function addZIndex(points) {
  return {
    ...points,
    items: points.items
      .sort((a, b) => b[1] - a[1])
      .map(([id, lat, lng, filters, ...data]) => [id, lat, lng, filters, zIndex++, ...data])
  };
}

function unmergeAllPoints(points) {
  const data = {
    ...points,
    items: points.items.map(([id, lat, lng, ...data]) => [id, round(lat), round(lng), ...data])
  };

  pipe(
    reduce((acc, point) => {
      const latLng = `${point[1]}-${point[2]}`;
      acc[latLng] = acc[latLng] || [];
      acc[latLng].push(point);
      return acc;
    }, {}),
    values,
    filter(points => points.length > 1),
    map(unmergePoints)
  )(data.items);

  return data;
}

function unmergePoints(points) {
  let level = 0;
  let counter = 0;
  let lastLevelIndex = -1;
  points.forEach((point, index) => {
    point[1] = +point[1] + level * POS_POSITION_LAT_DELTA;
    point[2] = +point[2] - level * POS_POSITION_LNG_DELTA + counter * POS_POSITION_LNG_DELTA * 2;
    counter++;
    if (index - lastLevelIndex === level + 1) {
      level++;
      lastLevelIndex = index;
      counter = 0;
    }
  });
}

function round(data) {
  return Math.round(data * 100000) / 100000;
}



// WEBPACK FOOTER //
// ./src/services/pointOfSale.js